<template>
  <div>
    <iModal :title="modelTitle" v-model="showModal" class-name="vertical-center-modal" width="500px"
      :mask-closable="false" @on-cancel="cancel">
      <div class="admin-add">
        <div class="admin-add-content">
          <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="right" :label-width="100"
            @submit.native.prevent>
            <FormItem label="头像：" prop="avatar">
              <upload ref="uploadAv" :config="avatarConfig" @upload-ok="bannerOK" :fileList="uploadBanner" />
            </FormItem>
            <FormItem label="头衔：" prop="actor">
              <Input v-model="formInline.actor" placeholder="请输入头衔" />
            </FormItem>
            <FormItem label="昵称：" prop="nickname">
              <Input v-model="formInline.nickname" placeholder="请输入昵称" />
            </FormItem>
            <FormItem label="密码：" prop="passwd" v-show="this.editId">
              <Input v-model="formInline.passwd" placeholder="请输入密码" />
            </FormItem>
            <FormItem label="角色权限：" prop="role">
              <Checkbox true-value="Y" false-value="N" v-model="formInline.chatListEnabled"
                :disabled="chatListDisabled">在线列表</Checkbox><br />
              <!-- <Checkbox true-value="Y" false-value="N" v-model="formInline.pageTurnEnabled"
                :disabled="pageTurnDisabled">PPT翻页</Checkbox><br /> -->
              <Checkbox true-value="Y" false-value="N" v-model="formInline.monitorEnabled" :disabled="monitorDisabled"
                @on-change="monitorChange">
                监播</Checkbox><br />
              <Checkbox true-value="Y" false-value="N" v-model="formInline.chatAuditEnabled"
                :disabled="chatAuditDisabled">聊天审核</Checkbox>
            </FormItem>
            <div class="u-tip" style="padding-left: 20px;">
              <Icon type="ios-information-circle-outline" />
              <div>
                1.PPT翻页、监播不能同时分配给多个账号使用<br />
                2.选择监播时，不能拥有其他权限<br />
                3.选择聊天审核时，不能拥有监播权限<br />
              </div>
            </div>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import upload from "@components/upLoad/upLoad";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "assistant-add",
  components: {
    upload,
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
    },
    modelTitle: {
      type: String,
    }
  },
  data () {
    let that = this;
    const validateAvatar = (rule, value, callback) => {
      if (that.uploadBanner && that.uploadBanner.length) {
        callback();
      } else {
        callback(new Error("请上传头像"));
      }
    };
    const validatePasswd = (rule, value, callback) => {
      if (!that.editId) {
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入密码"));
        } else {
          callback();
        }
      }
    };
    const validateRole = (rule, value, callback) => {
      // chatListEnabled：在线列表（仅支持助教）
      // pageTurnEnabled：翻页（仅支持助教，且仅能设置一个助教有翻页权限）
      // monitorEnabled：监播（仅支持助教，且仅能设置一个助教有监播权限）
      // chatAuditEnabled：聊天审核（仅支持助教）
      if (that.formInline.chatListEnabled === 'N' &&
        that.formInline.pageTurnEnabled === 'N' &&
        that.formInline.monitorEnabled === 'N' &&
        that.formInline.chatAuditEnabled === 'N') {
        callback(new Error("请选择角色权限"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      showModal: false,
      editId: '',
      uploadBanner: [], // 活动图
      formInline: {
        // form双向绑定
        avatar: "",
        actor: "助教",
        passwd: "",
        nickname: "",
        chatListEnabled: 'Y', // 在线列表（仅支持助教）
        pageTurnEnabled: 'N', // 翻页（仅支持助教，且仅能设置一个助教有翻页权限）
        monitorEnabled: 'N', // 监播（仅支持助教，且仅能设置一个助教有监播权限）
        chatAuditEnabled: 'Y', // 聊天审核（仅支持助教）
      },
      ruleInline: {
        avatar: [{ required: true, validator: validateAvatar, trigger: "change" }],
        actor: [{ required: true, message: "头衔不能为空", trigger: "blur" }],
        nickname: [{ required: true, message: "昵称不能为空", trigger: "blur" }],
        role: [{ required: true, validator: validateRole, trigger: "change" }],
        passwd: [{ required: true, validator: validatePasswd, trigger: "change" }],
      },
      config: {
        fileType: "img",
        headers: {},
        action: "",
        format: ["jpg", "jpeg", "png"],
        "max-size": 2048,
        remind:
          "(请上传 140 x 140 大小的图片，文件大小不超过2M)",
        limitNum: 1
      },
    };
  },
  computed: {
    channelId () {
      return this.$route.query.channelId;
    },
    activityId () {
      return this.$route.query.activityId;
    },
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
    }),
    avatarConfig () {
      let config = JSON.parse(JSON.stringify(this.config));
      config.id = "uploadAv";
      config.headers = this.formHeaders;
      config.action = this.uploadUrl;
      return config;
    },
    // 1.PPT翻页、监播不能同时分配给多个账号使用
    // 2.选择监播时，不能拥有其他权限
    // 3.选择聊天审核时，不能拥有监播权限
    chatListDisabled () { return this.formInline.monitorEnabled === 'Y' },
    pageTurnDisabled () { return this.formInline.monitorEnabled === 'Y' },
    monitorDisabled () { return this.formInline.chatAuditEnabled === 'Y' },
    chatAuditDisabled () { return this.formInline.monitorEnabled === 'Y' },
  },
  watch: {
    show (val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
    options (val) {
      if (val.msg) { // 编辑
        this.formInline.avatar = val.msg.avatar;
        this.uploadBanner = [val.msg.avatar];
        this.formInline.actor = val.msg.actor;
        this.formInline.nickname = val.msg.nickname;
        this.formInline.passwd = val.msg.passwd;
        this.formInline.chatListEnabled = val.msg.chatListEnabled;
        this.formInline.pageTurnEnabled = val.msg.pageTurnEnabled;
        this.formInline.monitorEnabled = val.msg.monitorEnabled;
        this.formInline.chatAuditEnabled = val.msg.chatAuditEnabled;
        this.editId = val.msg.id;
      }
    }
  },
  methods: {
    ...mapActions({
      createMember: "liveModule/createMember",
      updateMember: "liveModule/updateMember",
    }),
    bannerOK (list) {
      this.formInline.avatar = list[0];
      this.uploadBanner = list;
    },
    async handleSubmit (name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      this.loading = true;
      let purviewList = [];
      purviewList.push({ code: 'chatListEnabled', enabled: form.chatListEnabled });
      purviewList.push({ code: 'pageTurnEnabled', enabled: form.pageTurnEnabled });
      purviewList.push({ code: 'monitorEnabled', enabled: form.monitorEnabled });
      purviewList.push({ code: 'chatAuditEnabled', enabled: form.chatAuditEnabled });
      if (this.editId) { // 编辑模式
        let logo = this.uploadBanner[0];
        let req = {
          id: this.editId,
          request: {
            channelId: this.channelId,
            role: 'Assistant',
            actor: form.actor,
            account: this.options.msg.account,
            avatar: logo.indexOf('http') !== -1 ? logo : 'https:' + logo,
            nickname: form.nickname,
            passwd: form.passwd,
            purviewList: purviewList
          }
        };
        let bool = await this.updateMember(req).catch(err => {
          this.loading = false;
        });
        this.loading = false;
        if (bool && bool.data && bool.data.polyv && bool.data.polyv.updateMember) {
          this.$emit("finish");
          this.$Message.success("操作成功！");
          this.cancel();
        } else {
          let err = "操作失败，请重新尝试";
          if (bool.errors && bool.errors[0]) {
            err = bool.errors[0].message;
          }
          this.$Message.error(err);
        }
      } else { // 新增模式
        let req = {
          activityId: this.activityId,
          request: {
            channelId: this.channelId,
            role: 'Assistant',
            actor: form.actor,
            avatar: this.uploadBanner[0],
            nickname: form.nickname,
            purviewList: purviewList
          }
        };
        let bool = await this.createMember(req).catch(err => {
          this.loading = false;
        });
        this.loading = false; 
        if (bool && bool.data && bool.data.polyv && bool.data.polyv.createMember) {
          this.$emit("finish");
          this.$Message.success("操作成功！");
          this.cancel();
        } else {
          let err = "操作失败，请重新尝试";
          if (bool.errors && bool.errors[0]) {
            err = bool.errors[0].message;
          }
          this.$Message.error(err);
        }
      }
    },

    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel () {
      this.$refs["formInline"].resetFields();
      this.uploadBanner = [];
      this.editId = '';
      this.$emit("close");
    },
    monitorChange () {
      this.formInline.chatListEnabled = 'N';
      this.formInline.pageTurnEnabled = 'N';
      this.formInline.chatAuditEnabled = 'N';
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}

.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }

  &-content {
    .submit {
      display: flex;
      justify-content: center;

      button {
        margin-left: -75px;
      }
    }

    img {
      width: 150px;
      height: 150px;
    }
  }

  .form-code-item {
    position: relative;

    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;

      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

